import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router, RouterLinkActive } from '@angular/router';
import { Constants } from 'src/app/constants';
import { GroupIStateService } from '../../service/groupi-state.service';
import { FGAData } from 'src/app/fga/models';
import { Subscription } from 'rxjs';

@Component({
	selector: 'app-toolbar',
	templateUrl: './toolbar.component.html',
	styleUrls: ['./toolbar.component.scss'],
	standalone: false
})
export class ToolbarComponent implements OnInit, OnDestroy {
	@ViewChild('home') private readonly home: RouterLinkActive;
	enableHomeGrey = false;
	enableHomeRed = true;
	activeBoard: boolean = false;
	activeSubBoard: boolean = false;
	event: any;
	highlightGroupI = false;
	highlightKPI = false;
	highlightMGMT = false;
	highlightPCS = false;
	isAccessible = false;
	fgaDetails: FGAData | null = null;
	private subscription: Subscription;
	constructor(private readonly router: Router, private readonly state: GroupIStateService, private readonly constants: Constants) {
	}

	ngOnInit(): void {

		this.subscription = this.state.getDetails().subscribe(details => {
			const userData = sessionStorage?.getItem('FGA');
			let roles: any
			if (userData) {
				roles = JSON.parse(userData)?.roles
				const role = roles?.filter(r => r.displayName?.trim() == 'GroupI Admin') // NOSONAR
				this.isAccessible = role && role.length > 0 ? true : false;
			}
		});
	}

	ngOnDestroy() {
		console.info()

		this.event.unsubscribe();
		this.subscription.unsubscribe();
	}
	ngAfterContentChecked(): void {
		this.makeAllFalse();
		if (this.router.url == "/" || this.router.url == '/home') { // NOSONAR
			this.enableHomeRed = true;
			this.enableHomeGrey = false;
			this.activeBoard = true;
		}

		else if (this.router.url == '/tier-level' || this.router.url == '/route-level' || this.router.url == '/detail-level') { // NOSONAR
			this.highlightGroupI = true
		} else if (this.router.url == '/domicile' || this.router.url == '/assigneduser') { // NOSONAR
			this.highlightKPI = true;
		}
		else if (this.router.url == '/tier-setup' || this.router.url == '/history' || this.router.url == '/ew-configuration' || this.router.url == '/periods') { // NOSONAR
			this.highlightMGMT = true;
		}
		else if (this.router.url == '/contingency-master-tables' || this.router.url == '/contingency-pcs') { // NOSONAR
			this.highlightPCS = true;
		}

	}
	makeAllFalse() {
		this.activeBoard = false;
		this.enableHomeRed = false;
		this.enableHomeGrey = true;
		this.highlightGroupI = false;
		this.highlightKPI = false;
		this.highlightMGMT = false;
		this.highlightPCS = false;
	}

}
